import { Pipe, PipeTransform } from '@angular/core';

const KILO = 1024;
const MEGA = 1024 * 1024;
const GIGA = 1024 * 1024 * 1024;

const FORMAT = new Intl.NumberFormat('fr');

@Pipe({ name: 'filesize' })
export class FileSizePipe implements PipeTransform {
 
  transform(value: any, ...args: any[]) {
    
    if (typeof value !== 'number') {
      return value;
    }

    let suffix;
    let size;

    if (value < KILO) {
      suffix = 'octets';
      size = value;
    }
    else if (value < MEGA) {
      suffix = 'Ko';
      size = Math.round(value/KILO);
    }
    else if (value < GIGA) {
      suffix = 'Mo';
      size = Math.round(value/MEGA);
    }
    else {
      suffix = 'Go';
      size = Math.round(value/GIGA);
    }

    return `${FORMAT.format(size)} ${suffix}`;
  }
}
